var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JobDialog',{attrs:{"jobId":_vm.jobId ? parseInt(_vm.jobId, 10) : -1,"onClose":_vm.handleClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }